document.documentElement.classList.remove('no-js');
const qs=(s,c=document)=>c.querySelector(s), qsa=(s,c=document)=>[...c.querySelectorAll(s)];
const header=qs('[data-header]'); const updateHeader=()=>{const active=scrollY>20;header?.classList.toggle('scrolled',active);document.body.classList.toggle('header-scrolled',active)};window.addEventListener('scroll',updateHeader,{passive:true});updateHeader();
const carousel=qs('[data-carousel]'); if(carousel){const slides=qsa('[data-slide]',carousel),progress=qs('[data-progress]',carousel);let index=0,timer;const show=i=>{index=(i+slides.length)%slides.length;slides.forEach((s,n)=>s.classList.toggle('active',n===index));if(progress)progress.style.width=((index+1)/slides.length*100)+'%'};const play=()=>{clearInterval(timer);timer=setInterval(()=>show(index+1),5500)};qs('[data-next]',carousel)?.addEventListener('click',()=>{show(index+1);play()});qs('[data-prev]',carousel)?.addEventListener('click',()=>{show(index-1);play()});show(0);play()}
if('IntersectionObserver'in window){const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('visible');io.unobserve(e.target)}}),{threshold:.14});qsa('.reveal').forEach(el=>io.observe(el))}else qsa('.reveal').forEach(el=>el.classList.add('visible'));
const form=qs('[data-product-form]');
if(form){
  const select=qs('[data-variant-select]',form);
  const price=qs('[data-product-price]');
  const button=qs('[data-add-button]',form);
  const radios=qsa('input[type=radio]',form);
  const stockModule=qs('[data-stock-module]');
  const variantStock=qs('[data-variant-stock]');
  const lowThreshold=Number(stockModule?.dataset.lowThreshold||9);
  const showExactVariant=stockModule?.dataset.showExactVariant==='true';

  const updateVariantStock=(option)=>{
    if(!variantStock||!option)return;
    const managed=option.dataset.inventoryManaged==='true';
    const available=option.dataset.available==='true';
    const inventory=Number(option.dataset.inventory||0);
    const policy=option.dataset.inventoryPolicy;

    variantStock.classList.toggle('is-low',managed&&available&&inventory>0&&inventory<=lowThreshold);
    variantStock.classList.toggle('is-out',!available);

    if(!managed){
      variantStock.textContent='Cette variante est disponible.';
    }else if(!available){
      variantStock.textContent='Cette variante est épuisée.';
    }else if(inventory<=0&&policy==='continue'){
      variantStock.textContent='Disponible sur commande pour cette variante.';
    }else if(showExactVariant){
      variantStock.textContent=`${inventory} disponible${inventory===1?'':'s'} pour cette variante.`;
    }else if(inventory<=lowThreshold){
      variantStock.textContent='Stock faible pour cette variante.';
    }else{
      variantStock.textContent='Cette variante est en stock.';
    }
  };

  const update=()=>{
    const chosen=qsa('.variant-fieldset',form).map(fs=>qs('input:checked',fs)?.value);
    const option=[...select.options].find(o=>{
      try{return JSON.stringify(JSON.parse(o.dataset.options))===JSON.stringify(chosen)}
      catch{return false}
    })||select.options[select.selectedIndex];

    if(option){
      select.value=option.value;
      if(price)price.textContent=option.dataset.price;
      const available=option.dataset.available==='true'&&!option.disabled;
      button.disabled=!available;
      button.textContent=available?'Commander mon Starter Pack':'Épuisé';
      updateVariantStock(option);
    }
  };

  radios.forEach(r=>r.addEventListener('change',update));
  select?.addEventListener('change',update);
  update();
}


// V9.2 — Preserve image definition: no scroll zoom on product chapters.
(() => {
  const panels=[...document.querySelectorAll('.story-panel')];
  panels.forEach(panel=>{
    const image=panel.querySelector('img');
    if(image){
      image.style.transform='none';
      image.style.willChange='auto';
    }
  });
  window.addEventListener('scroll',()=>{
    panels.forEach(panel=>{
      const image=panel.querySelector('img');
      if(image) image.style.transform='none';
    });
  },{passive:true});
})();


/* V14.3 — navigation et traduction FR/EN */
document.addEventListener('DOMContentLoaded', () => {
  const languageButtons = document.querySelectorAll('[data-language]');

  const applyLanguage = (language) => {
    const lang = language === 'en' ? 'en' : 'fr';
    document.documentElement.lang = lang;
    document.querySelectorAll('[data-fr][data-en]').forEach((element) => {
      const value = element.dataset[lang];
      if (typeof value === 'string') element.innerHTML = value;
    });
    languageButtons.forEach((button) => {
      const active = button.dataset.language === lang;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    try { localStorage.setItem('fitiny-language', lang); } catch (error) {}
  };

  languageButtons.forEach((button) => {
    button.addEventListener('click', () => applyLanguage(button.dataset.language));
  });

  let initialLanguage = 'fr';
  try {
    initialLanguage = localStorage.getItem('fitiny-language') || 'fr';
  } catch (error) {}
  applyLanguage(initialLanguage);

  const navLinks = [...document.querySelectorAll('.desktop-nav a[href*="#"]')];
  const sections = navLinks
    .map((link) => {
      const id = link.getAttribute('href').split('#')[1];
      return id ? document.getElementById(id) : null;
    })
    .filter(Boolean);

  if ('IntersectionObserver' in window && sections.length) {
    const observer = new IntersectionObserver((entries) => {
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (!visible) return;
      navLinks.forEach((link) => {
        link.classList.toggle('is-active', link.getAttribute('href').endsWith(`#${visible.target.id}`));
      });
    }, { rootMargin: '-30% 0px -58% 0px', threshold: [0.01, 0.2, 0.5] });
    sections.forEach((section) => observer.observe(section));
  }
});


/* V16.4.2 — Pack intention dialogs: one submitted pack, one confirmation */
document.addEventListener('DOMContentLoaded',()=>{
  const storageKey='fittinySubmittedIntent';

  const openDialog=(dialog)=>{
    if(!dialog)return;
    if(typeof dialog.showModal==='function'){
      if(!dialog.open)dialog.showModal();
    }else{
      dialog.setAttribute('open','');
    }
    document.body.classList.add('intent-dialog-open');
  };

  const closeDialog=(dialog)=>{
    if(!dialog)return;
    if(typeof dialog.close==='function'&&dialog.open)dialog.close();
    else dialog.removeAttribute('open');
    if(!document.querySelector('.intent-dialog[open]')){
      document.body.classList.remove('intent-dialog-open');
    }
  };

  document.querySelectorAll('[data-intent-open]').forEach(button=>{
    button.addEventListener('click',()=>openDialog(document.getElementById(button.dataset.intentOpen)));
  });

  document.querySelectorAll('.intent-form').forEach(form=>{
    form.addEventListener('submit',()=>{
      const dialog=form.closest('.intent-dialog');
      if(!dialog)return;
      try{sessionStorage.setItem(storageKey,dialog.id)}catch(error){}
    });
  });

  const hashToDialog={
    SupporterIntentForm:'supporter-intent',
    StarterIntentForm:'starter-intent',
    FounderIntentForm:'founder-intent'
  };

  let submittedDialogId='';
  try{submittedDialogId=sessionStorage.getItem(storageKey)||''}catch(error){}

  if(!submittedDialogId){
    const hash=decodeURIComponent(window.location.hash.replace(/^#/,''));
    submittedDialogId=hashToDialog[hash]||(
      document.getElementById(hash)?.classList.contains('intent-dialog') ? hash : ''
    );
  }

  let resultDialog=null;

  document.querySelectorAll('.intent-dialog').forEach(dialog=>{
    const success=dialog.querySelector('.intent-success');
    const fields=dialog.querySelector('.intent-form-fields');
    const errors=dialog.querySelector('.errors');
    const isSubmitted=Boolean(submittedDialogId)&&dialog.id===submittedDialogId;

    if(success)success.hidden=!isSubmitted;
    if(fields)fields.hidden=Boolean(success)&&isSubmitted;

    if(errors&&!isSubmitted)errors.hidden=true;

    dialog.querySelectorAll('[data-intent-close]').forEach(button=>{
      button.addEventListener('click',()=>closeDialog(dialog));
    });

    dialog.addEventListener('click',(event)=>{
      if(event.target===dialog)closeDialog(dialog);
    });

    dialog.addEventListener('close',()=>{
      if(!document.querySelector('.intent-dialog[open]')){
        document.body.classList.remove('intent-dialog-open');
      }
    });

    if(isSubmitted&&(success||errors))resultDialog=dialog;
  });

  if(resultDialog){
    openDialog(resultDialog);
    try{sessionStorage.removeItem(storageKey)}catch(error){}
  }

  document.addEventListener('keydown',(event)=>{
    if(event.key==='Escape'){
      document.querySelectorAll('.intent-dialog[open]').forEach(closeDialog);
    }
  });
});

